export const ASSIGNEES = ['john', 'katie', 'brent', 'andrew'] as const
export const STATUSES = ['waiting', 'ready', 'in_progress'] as const

export type Assignee = (typeof ASSIGNEES)[number]
export type Status = (typeof STATUSES)[number]

export type Card = {
  id: string
  title: string
  notes: string | null
  assignee: Assignee
  status: Status
  dueDate: string | null
  waitingOn: string | null
  position: number
  doneAt: string | null
  createdAt: string
  updatedAt: string
}

export type Person = {
  id: Assignee
  name: string
  avatar: string
}

export const PEOPLE: Person[] = [
  { id: 'john', name: 'John', avatar: '/avatars/john.jpg' },
  { id: 'katie', name: 'Katie', avatar: '/avatars/katie.jpg' },
  { id: 'brent', name: 'Brent', avatar: '/avatars/brent.jpg' },
  { id: 'andrew', name: 'Andrew', avatar: '/avatars/andrew.jpg' },
]

export const personOf = (id: Assignee): Person =>
  PEOPLE.find((p) => p.id === id) ?? PEOPLE[0]!

type ColumnMeta = {
  id: Status
  label: string
  /** Tailwind class for the rule above the column heading. */
  accent: string
}

export const COLUMNS: ColumnMeta[] = [
  { id: 'waiting', label: 'Waiting', accent: 'bg-faint' },
  { id: 'ready', label: 'Ready to Start', accent: 'bg-teal-400' },
  { id: 'in_progress', label: 'In Progress', accent: 'bg-ember' },
]
